import { createUserInfoSource, FailureCauseError } from '@forest/paywall-core'
import { native } from '@forest/native-services'
import { atom } from 'nanostores'
import type { UserInfo } from './types'

export const $selectedPlan = atom<'annual' | 'monthly'>('annual')

export const userInfoSource = createUserInfoSource({
  load: async () => {
    if (import.meta.env.DEV) {
      return {
        user_id: 0,
        token: '123',
        server: 'staging',
        user_type: 'legacy',
      } satisfies UserInfo
    }
    const result = await native.user.getUserInfo()
    if (!result.success) {
      throw new FailureCauseError('native_failed', 'Failed to get user info')
    }
    if (!result.data) {
      throw new FailureCauseError('no_user', 'Native has no user info')
    }
    return result.data
  },
  refresh: async () => {
    const result = await native.user.refreshToken()
    if (!result.success) {
      throw new FailureCauseError(
        'token_refresh_failed',
        'Failed to refresh token',
      )
    }
    return result.data
  },
})

export const $userInfo = userInfoSource.atom

export const $subscribedView = atom<{ isChinaAndroidTrial: boolean } | null>(
  null,
)

export const $chinaAndroidTrialEligibility = atom<
  'pending' | 'available' | 'unavailable'
>('pending')

export const $isReminderViewOpen = atom(false)

export const $receiptSystemAccountId = atom<string | null>(null)
